var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 141 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/building03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/building03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house",
    transform: "translate(20.000000, 53.000000)",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.55271368e-15 L0,32.1726394 L0,46.4046514 C0,51.6820931 4.27751463,56 9.56812483,56 C9.65254946,56 9.70883254,56 9.79325717,56 C9.87768181,56 9.93396489,56 10.0183895,56 L29.8863193,56 C34.839231,56 38.8634717,51.9643093 38.8634717,46.9973053 L38.8634717,23.6966065 C38.8634717,22.9346229 39.4825857,22.3137475 40.2424074,22.3137475 L60.7575926,22.3137475 C61.5174143,22.3137475 62.1365283,22.9346229 62.1365283,23.6966065 L62.1365283,46.9973053",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-4.97379915e-13,72 L33.0963518,39.8359398 M46.2591663,27.0439088 L71,3 L139.070313,69.6308594",
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.102539,58 L125.102539,99.8525391 C125.102539,104.823102 121.073102,108.852539 116.102539,108.852539 L91.090158,108.852539 C86.1195952,108.852539 82.090158,104.823102 82.090158,99.8525391 C82.090158,99.8226364 82.090307,99.7927338 82.0906051,99.7628326 L82.1,98.8203125",
    id: "Path-10",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(27.000000, 21.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11,
    y: 0,
    width: 4,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    transform: "translate(13.000000, 12.500000) rotate(90.000000) translate(-13.000000, -12.500000) ",
    x: 11,
    y: 0,
    width: 4,
    height: 25,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(22.000000, 6.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 4,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    transform: "translate(8.000000, 7.500000) rotate(90.000000) translate(-8.000000, -7.500000) ",
    x: 6,
    y: 0,
    width: 4,
    height: 15,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(2.000000, 23.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 4,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    transform: "translate(8.000000, 7.500000) rotate(90.000000) translate(-8.000000, -7.500000) ",
    x: 6,
    y: 0,
    width: 4,
    height: 15,
    rx: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingNew);
export default __webpack_public_path__ + "static/media/building-new.04495d1b7b5fd10cfe8aca8a35aa6a10.svg";
export { ForwardRef as ReactComponent };